import { Injectable } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { SideListOptionType } from '@fi-shared/types';

@Injectable()
export class FiItemsEditHelperService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    showEditRestoreConfirm(
        itemName: string,
        isItemDeleted: boolean,
        goToEditFn: () => void,
        restoreFn: () => Promise<void>,
    ) {
        if (!isItemDeleted) {
            goToEditFn();
            return;
        }
        this.fiDialogsService
            .confirm({
                headerText: this.appTextService.get('common.edit_restore_dialog_header'),
                messageText: this.appTextService.get('common.edit_restore_dialog_text', { '{item_name}': itemName }),
                yesButtonText: this.appTextService.get('common.edit_restore_dialog_ok_button'),
                noButtonText: this.appTextService.get('common.close'),
            })
            .onYesButtonClick(() => {
                restoreFn().then(() => goToEditFn());
            });
    }
}
